'use client';

import { motion } from 'framer-motion';
import Skeleton from './LoadingSkeleton';

export const OurMissionLoadingSkeleton = () => {
  return (
    <motion.section 
      className="py-20"
      style={{ backgroundColor: '#203F72' }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div 
          className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center rounded-3xl p-8"
          style={{
            border: '2px dashed #B5CEFC',
            backgroundColor: '#203F72'
          }}
        >
          {/* Left Side - Image Skeleton */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <Skeleton className="aspect-[4/3] w-full" />
            </div>
          </div>

          {/* Right Side - Content Skeleton */}
          <div className="text-white">
            {/* Badge Skeleton */}
            <Skeleton className="h-4 w-24 mb-2" style={{ backgroundColor: '#B5CEFC' }} />
            
            {/* Title Skeleton */}
            <Skeleton className="h-12 w-full mb-6" style={{ backgroundColor: '#FFFFFF' }} />
            
            {/* Subtitle Skeleton */}
            <div className="space-y-2 mb-8">
              <Skeleton className="h-5 w-full" style={{ backgroundColor: '#FFFFFF' }} />
              <Skeleton className="h-5 w-full" style={{ backgroundColor: '#FFFFFF' }} />
              <Skeleton className="h-5 w-3/4" style={{ backgroundColor: '#FFFFFF' }} />
            </div>
            
            {/* Button Skeleton */}
            <Skeleton className="h-12 w-32 rounded-lg" style={{ backgroundColor: '#81A3F8' }} />
          </div>
        </div>
      </div>
    </motion.section>
  );
};
